import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import InlineSvg from 'vue-inline-svg'
import { useRouter } from 'vue-router'
import { inject } from 'vue'

import logo from '@/assets/logo.svg'
import { useStore } from '@/store'

export default /*#__PURE__*/_defineComponent({
  __name: 'Logo',
  setup(__props) {

const emitter = inject('emitter')

const store = useStore()
const router = useRouter()
const nav = () => {
  router.push('/')
  emitter.emit('close.modal')
  store.menuOpened = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["logo", { 'is-opened': _unref(store).menuOpened, 'is-inverted': _unref(store).menuInverted }])
  }, [
    _createVNode(_unref(InlineSvg), {
      src: _unref(logo),
      onClick: nav
    }, null, 8, ["src"])
  ], 2))
}
}

})